import { ASSETS_LOCATIONS, getAssetsUrl } from '../../utilities/constants';
import { RESERVATION_DETAIL_IMAGES } from './assets/images';

export const ORDER_STATUS = {
  canceled: 'CANCELED',
  reserved: 'RESERVED'
};
export const INFO_SECTION_ID = 'info-section';
export const ADDITIONAL_PACKAGE_SECTION = 'additional-package-section';

export const DEFAULT_TIER_EVENT_CALENDAR_TILE = {
  image: `${getAssetsUrl(ASSETS_LOCATIONS.CONTENT, RESERVATION_DETAIL_IMAGES.GREAT_CLOCK_TOWER_SHOW)}`,
  headline: `Keep playing with our events`,
  description: `Explore the lodge and discover new fun with your pack in between water park splashes!`,
  buttonLabel: 'Download Our App',
  highlight: true,
  packageType: 'Default'
};

export const SEASON_PASS_EVENT_CALENDAR_TILE = {
  image: `${getAssetsUrl(ASSETS_LOCATIONS.CONTENT, RESERVATION_DETAIL_IMAGES.GREAT_CLOCK_TOWER_SHOW)}`,
  headline: `Start planning your visit and use your season pass`,
  description: [
    'Water park access included with every visit',
    'Visit as often as you want—only pay once!',
    'Join us throughout the day for free, fun and engaging family events in between splash sessions in the water park.'
  ],
  buttonLabel: 'Book A Day Pass',
  highlight: true,
  packageType: 'Default'
};

export const IMAGES = {
  wileyReservation: getAssetsUrl(ASSETS_LOCATIONS.ROOT, RESERVATION_DETAIL_IMAGES.WILEY_RESERVATION),
  waveSVG: getAssetsUrl(ASSETS_LOCATIONS.SVG, RESERVATION_DETAIL_IMAGES.WAVE_BG),
  bestValueRibbon3: getAssetsUrl(ASSETS_LOCATIONS.ROOT, RESERVATION_DETAIL_IMAGES.BEST_VALUE_RIBBON_3),
  bestValueRibbon4: getAssetsUrl(ASSETS_LOCATIONS.ROOT, RESERVATION_DETAIL_IMAGES.BEST_VALUE_RIBBON_4),
  bestValueRibbon5: getAssetsUrl(ASSETS_LOCATIONS.ROOT, RESERVATION_DETAIL_IMAGES.BEST_VALUE_RIBBON_5)
};

export const ADDONS_PACKAGE_IMAGE = {
  Passes: getAssetsUrl(ASSETS_LOCATIONS.SVG, RESERVATION_DETAIL_IMAGES.ATTRACTION_ADDONS),
  Birthday: getAssetsUrl(ASSETS_LOCATIONS.SVG, RESERVATION_DETAIL_IMAGES.BIRTHDAY_ADDONS),
  Dining: getAssetsUrl(ASSETS_LOCATIONS.SVG, RESERVATION_DETAIL_IMAGES.DINING_ADDONS),
  Cabana: getAssetsUrl(ASSETS_LOCATIONS.SVG, RESERVATION_DETAIL_IMAGES.CABANA_ADDONS)
};

export const ADDONS_CARD_TITLE = {
  Passes: 'Attraction Passes',
  Birthday: 'Birthday Package',
  Dining: 'Deals Added'
};

export const ADDONS_CARD_AMOUNT_TITLE = {
  Passes: 'Attraction Passes',
  Birthday: 'Birthday Package',
  Dining: 'Dining Deals'
};

export const ADDONS_CARD_MODAL_TITLE = {
  Passes: 'Your Attraction Passes',
  Birthday: 'Your Birthday Packages',
  Dining: 'Your Dining Packages'
};

export const ADDONS_CTA_TEXT = {
  Passes: 'Add More Passes',
  Birthday: 'Add a Package',
  Dining: 'Add a Deal',
  Bundle: 'See Details'
};

// Standard success and error messages
export const NOTIFICATION_MESSAGES = {
  addLCOSuccess: 'You added <b>Late Check-Out</b> to your reservation!',
  addLCOFailed: 'Failed to add <b>Late Check-Out</b> to your reservation'
};

// Type of response, success or error
export const NOTIFICATION_TYPE = {
  success: 'success',
  failed: 'error'
};
